<vue-dropzone
    :ref="refId"
    :id="refId"
    :options="dropzoneOptions"
    v-show="!getAttribute('statusUploaded')"
    @vdropzone-complete="afterComplete"
    @vdropzone-sending="sendFile"
    @vdropzone-file-added="fileAdded"
    @vdropzone-drop="drop"
    @vdropzone-error="error"
    @vdropzone-mounted="mounted"
    @vdropzone-upload-progress="progress"
  >
</vue-dropzone>